import { Link, usePage } from "@inertiajs/react"

import { useFilteredItems } from "@/hooks/use-filtered-nav"
import { detectSection, isActiveLink, isGroup, sections } from "@/lib/nav-data"

export function SecondaryNav() {
  const { url } = usePage()
  const currentPath = url.split("?")[0]
  const currentUrl = url
  const sectionKey = detectSection(currentPath)
  const section = sections[sectionKey]
  const displayItems = useFilteredItems(sectionKey, section?.items ?? [])

  if (!section) return null

  return (
    <nav className="border-hpi-light-gray bg-hpi-pale-gray flex w-[180px] shrink-0 flex-col overflow-y-auto border-r">
      <div className="px-5 pt-5 pb-2">
        <h2 className="text-hpi-dark-blue text-lg font-medium">
          {section.title}
        </h2>
      </div>
      <div className="flex flex-col gap-0.5 px-3 pb-4">
        {displayItems.map((entry) =>
          isGroup(entry) ? (
            <div key={entry.label} className="mt-2">
              <div className="text-hpi-dark-blue px-2 pb-1 text-[13px] font-medium">
                {entry.label}
              </div>
              <div className="flex flex-col gap-0.5 pl-2">
                {entry.children.map((child) => (
                  <NavItem
                    key={child.label}
                    label={child.label}
                    href={child.href}
                    active={isActiveLink(child.href, currentUrl)}
                  />
                ))}
              </div>
            </div>
          ) : (
            <NavItem
              key={entry.label}
              label={entry.label}
              href={entry.href}
              active={isActiveLink(entry.href, currentUrl)}
            />
          ),
        )}
      </div>
    </nav>
  )
}

export function NavItem({
  label,
  href,
  active,
  onClick,
}: {
  label: string
  href: string
  active: boolean
  onClick?: () => void
}) {
  const isPlaceholder = href.startsWith("#")

  if (isPlaceholder) {
    return (
      <span
        className="text-hpi-med-gray cursor-default rounded px-2 py-1 text-[13px]"
        title="Coming soon"
      >
        {label}
      </span>
    )
  }

  return (
    <Link
      href={href}
      prefetch
      onClick={onClick}
      className={`rounded px-2 py-1 text-[13px] transition-colors ${
        active
          ? "text-hpi-active-blue font-medium"
          : "text-hpi-dark-blue hover:bg-hpi-pale-blue hover:text-hpi-active-blue"
      }`}
    >
      {label}
    </Link>
  )
}
